module.exports = __webpack_public_path__ + "img/img9.ae0ad00d.svg";